import React from "react";
import { Send, MessageCircle, Loader2 } from "lucide-react";
import { Switch } from "../../components/ui/switch";

export default function MessageThread({
  messages, newMessage, setNewMessage,
  sendViaWhatsApp, setSendViaWhatsApp,
  sendingMessage, onSend,
}) {
  return (
    <div className="lg:col-span-2 bento-card flex flex-col h-[600px]">
      <h2 className="text-lg font-medium text-[#1C1917] mb-4 pb-3 border-b border-[#E7E5E4]" style={{ fontFamily: "Playfair Display, serif" }}>
        Message Thread
      </h2>

      <div className="flex-1 overflow-y-auto space-y-3 mb-4" data-testid="messages-container">
        {messages.length === 0 ? (
          <div className="text-center text-[#A8A29E] py-8">No messages yet</div>
        ) : (
          messages.map((msg) => (
            <div key={msg.id} className={msg.direction === "incoming" ? "message-incoming" : "message-outgoing"} data-testid={`message-${msg.id}`}>
              <p className="text-sm">{msg.content}</p>
              <div className="flex items-center gap-2 mt-1">
                <p className="text-xs text-[#A8A29E]">
                  {new Date(msg.timestamp).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
                </p>
                {msg.sent_via_whatsapp && (
                  <span className="text-xs text-green-600 flex items-center gap-0.5">
                    <MessageCircle size={10} /> WhatsApp
                  </span>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      <div className="border-t border-[#E7E5E4] pt-4">
        <div className="flex items-center justify-between mb-3">
          <label className="flex items-center gap-2 text-sm text-[#57534E]">
            <Switch checked={sendViaWhatsApp} onCheckedChange={setSendViaWhatsApp} data-testid="whatsapp-toggle" />
            <MessageCircle size={16} className={sendViaWhatsApp ? "text-green-600" : ""} />
            Send via WhatsApp
          </label>
        </div>
        <form onSubmit={onSend} className="flex gap-2">
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder={sendViaWhatsApp ? "Type a WhatsApp message..." : "Add an internal note..."}
            className="form-input flex-1"
            disabled={sendingMessage}
            data-testid="message-input"
          />
          <button
            type="submit"
            disabled={sendingMessage || !newMessage.trim()}
            className={`btn-primary p-3 ${sendViaWhatsApp ? "bg-green-600 hover:bg-green-700" : ""}`}
            data-testid="send-message-btn"
          >
            {sendingMessage ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
          </button>
        </form>
      </div>
    </div>
  );
}
